<template>
  <div>
    <ministry-breadcrumbs :mainTitle="mainTitle" :breadcrumbs="breadcrumbs" />
    <b-card>
      <div style="position: relative">
        <div  v-if="options.length === 0">
          <b-alert variant="danger" show class="w-100 mt-2 mb-10">
            <div class="alert-body">
              <feather-icon icon="InfoIcon" size="16" class="mx-50" />
              ليس لديك صلاحيات في المعاملات
            </div>
          </b-alert>
        </div>
        <div v-else>

          <b-row>
            
            <b-col cols="12">
              <p>
                تعقيب معاملات بصفة
              </p>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio-group
                  v-model="activeRole"
                  :options="options"
                  :aria-describedby="ariaDescribedby"
                  button-variant="outline-primary"
                  name="radio-btn-outline"
                  buttons
                />
              </b-form-group>
            </b-col>
           
          </b-row>
          <hr />
          <b-row class="justify-content-between px-1 align-items-center">
            
            <b-col>
              <transaction-filters  class="mt-1" @filterChanged="onFilterChanged" />
            </b-col>
            
  
            <b-col cols="4"  class="d-flex justify-content-end">
              <b-button variant="info" size="lg" @click="isSearchVisible = true">
            
                <feather-icon size="20" icon="SearchIcon" /> 
                <span>
                الإستعلام عن معاملة
                </span>
              </b-button>
            </b-col>
          </b-row>
          <hr />
          
          <data-table
            id="ngos-table"
            ep="v2/ministry/transaction-requests"
            :fields="tableFields"
            ref="transactionsTable"
            striped
            
          >
            <template #cell(lastActionHistoryStatus)="{ value }">
              <transactions-status-formatter :value="value" />
            </template>
            <template #cell(createdBy)="row">
              <span v-if="row.item.transactionType.id == 7">{{ row.item.createdByEstablishmentAccount }} </span>
              <span v-else>{{ row.item.createdBy.full_name }} </span>
            </template>
            <template #cell(status)="{ value }">
              <transactions-status-formatter :value="value" />
            </template>
            <template #cell(created_at)="{ value }">
              <span
                >{{ value ? formatDate(value, "YYYY-MM-DD") : "" }}
              </span>
            </template>
            <template #cell(updated_at)="{ value }">
              <span
                >{{ value ? formatDate(value, "YYYY-MM-DD") : "" }}
              </span>
            </template>
            <template #cell(end_date)="{ item }" >
              <span v-if="item.transactionType.total_duration === 0">
                -
              </span>
              <span v-else>
                <b-badge v-if="specifiedPeriodHasExceeded(item.end_date)" variant="light-danger"> نعم </b-badge>
                <b-badge v-else variant="light-success"> لا </b-badge>
              </span>
            </template>
            
            <template #cell(actions)="{ item }">
              <b-dropdown
                variant="link"
                no-caret
                :left="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item
                  target="_blank"
                  @click="$router.push({ path: `accreditation-transactions/${item.id}` })"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">عرض المعاملة</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="activeFilter === 'all' && (activeRole !== 'employee' && activeRole !== 'head_of_ngo_department' && activeRole !== 'central_employee' && activeRole !== 'head_of_regulation_and_governance')"
                  @click="onClickedReAssignment(item.id)"
                >
                  <feather-icon icon="ListIcon" />
                  <span class="align-middle ml-50"> إعادة إسناد </span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </data-table>
        </div>
       
      </div>
    </b-card>
    <re-assignment 
      v-model="reAssignment" 
      @confirm="onConfirmReAssignment"
      ref="reAssignment"
      :loading="loadingStrating" 
      :intializeForm="form"
      ></re-assignment>

   <transaction-inquiry ref="transactionInquiry" v-model="isSearchVisible"></transaction-inquiry></div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BDropdown,
  BDropdownItem,
  BBadge,
  BLink,
  BModal,
  BImg,
  BFormGroup, BFormRadioGroup 
} from "bootstrap-vue";
import { BAlert } from "bootstrap-vue";
import { formatDate } from "@/utils/utils";
import transactionInquiry from "./transactionInquiry.vue"
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import ReAssignment from "../accreditation-transactions/components/ReAssignment.vue";
import DataTable from "@/components/data-table";
import { mapActions, mapGetters } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormModal from "@/components/FormModal.vue";
import debounce from "lodash.debounce";
import TransactionFilters  from "../../../../components/TransactionFilters.vue";
import RolesFilters from "../../../../components/RolesFilters.vue";
import loaderBtn from "@/components/loader-btn";
import SearchInput from "@/components/SearchInput.vue";
import authHelpers from "@/utils/auth-helpers";
import TransactionsStatusFormatter from "@/modules/ngo/transactions/components/TransactionsStatusFormatter.vue";
import formAutocomplete from "@/components/form-autocomplete";
import FormSelect from "@/components/form-select";
import FormMask from "@/components/form-mask";
import FormInput from "@/components/form-input";
import { ifSpecifiedPeriodHasExceeded } from "@/utils/utils";


export default {
  components: {
    BBadge,
    formAutocomplete,
    SearchInput,
    BRow,
    BCol,
    BCard,
    BButton,
    BDropdown,
    BDropdownItem,
    MinistryBreadcrumbs,
    DataTable,
    TransactionFilters ,
    BLink,
    BModal ,
    BBadge ,
    BImg , 
    loaderBtn , 
    FormModal , 
    TransactionsStatusFormatter ,
    RolesFilters , 
    BFormGroup, BFormRadioGroup ,
    FormInput , FormMask , FormSelect ,
    transactionInquiry , BAlert , ReAssignment
    
  },

  data() {
    return {
      loading:false,
      showTransiction : false ,
      isCatched : false , 
      feedbackContent : null ,
      idToSendReply : null ,
      replyModal : false , 
      reAssignment : false ,
      replyVeiwModal : false ,
      isSearchVisible : false ,
      form: {},
      listOptions:[],
      mainTitle: "إدارة المعاملات",
      breadcrumbs: [
        {
          text: "الإعدادات",
          to: "/ministry/settings",
        },
        {
          text: "طلبات المعاملات",
          active: true,
        },
      ],
      activeFilter: "",
      activeRole : null ,
      searchKey: {},
      fields: [
        { label: "المعرف", key: "id" },
        { label: "نوع المعاملة", key: "transactionType.name" },
        { label: "الجهة المقدمة للمعاملة", key: "ngo.name_ar" },
        { label: "حالة المعاملة", key: "status" },
        // { label: "عدد الأيام المخصصة للمعاملة", key: "transactionType.total_duration" },
        { label: "تاريخ تقديم المعاملة", key: "created_at" },
        // { label: "  تجاوزت المدة المحددة ؟", key: "end_date" },
        // { label: "الشكل القانوني للجهة المقدمة للمعاملة", key: "calculatedWeight.completion_value" },
        // { label: "مقدم المعاملة", key: "completedByDirectorate.full_name" },
        // { label: "محافظ المقر", key: "ompleted_by_ngo_at" },
       
      ],
      
    };
  },
  watch: {
    searchKey: debounce(function (value) {
      this.$refs.transactionsTable.setQueryParams({
        search: value,
        tab: this.activeFilter,
      });
      this.$refs.transactionsTable.refreshTable();
    }, 300),
    activeFilter(val) {
      localStorage.setItem("tab", val);
      this.$refs.transactionsTable.setQueryParams({ search: this.searchKey, tab: val , transaction_role_slug : this.activeRole });
      this.$refs.transactionsTable.refreshTable();
    },
    listOptions(val){
      this.activeRole = this.options[0].value
    },
    activeRole(val) {
      localStorage.setItem("typeOfRole", this.activeRole);
      this.$refs.transactionsTable.setQueryParams({ search: this.searchKey, tab: this.activeFilter , transaction_role_slug : this.activeRole });
      this.$refs.transactionsTable.refreshTable();
    },
    
  },
  mounted() {
    this.activeFilter = "all"
  },
  computed:{
    ...mapGetters("Ministry/Settings/Transaction", ["loadingStrating"]),
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    options() {
      if(authHelpers.getTransactionRoles().some(item => item.slug === "employee") ){
        
        
        this.listOptions.push({ text: "موظف", value: "employee"  })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "head_of_ngo_department")){
        this.listOptions.push({ text: "رئيس دائرة المنظمات غير الحكومية", value: "head_of_ngo_department" })
      }
      if (authHelpers.getTransactionRoles().some(item => item.slug === "director_of_social_affairs_and_labor")){
        this.listOptions.push({ text: "مدير الشؤون الاجتماعية والعمل", value: "director_of_social_affairs_and_labor" })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "central_employee")){
        this.listOptions.push({ text: 'موظف مركزي', value: "central_employee" })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "head_of_regulation_and_governance"))
      {
        this.listOptions.push({ text: "رئيس دائرة مركزي", value: "head_of_regulation_and_governance"  })
      }
      if(authHelpers.getTransactionRoles().some(item => item.slug === "director_of_ngos")){
        this.listOptions.push({ text: 'مدير المنظمات غير الحكومية', value: "director_of_ngos" })
      }
      
      return this.listOptions  ;
    },
    
    tableFields() {
      var actionsField = { label: " ", key: "actions" };
      var isAll ={ 
        label: "تاريخ إخر تعديل على المعاملة",
        key: "updated_at",
      };
      var totalDuration ={ 
        label: "الحد الأقصى لإنجاز المعاملة",
        key:  "transactionType.total_duration",
      };
      var isOver ={ 
        label: " تجاوزت المدة المحددة ؟",
        key:  "end_date",
      };
      var whocreated ={ 
        label: " مُقدم المعاملة ",
        key:  "createdBy",
      };
      var needChecking = { 
        label: "حالة الإجراء السابق",
        key: "lastActionHistoryStatus" 
      };
      var currentMinistryUser = { 
        label: "الموظف الذي يقوم بتعقيب المعاملة",
        key: "currentMinistryUser.full_name" 
      };
      var currentMinistryUserRole= { 
        label: "دور الموظف الذي يقوم بتعقيب المعاملة",
        key: "currentMinistryUserRole.name" 
      };
      
      return this.activeFilter === "all"
        ? [
            ...this.fields,
            whocreated ,
            currentMinistryUser ,
            currentMinistryUserRole ,
            isAll , 
            totalDuration,
            isOver ,
            actionsField,
          ]
        : this.activeFilter === "need_checking" || this.activeFilter === "returned_from_higher_level" || this.activeFilter === "under_checking"
        ? [
            ...this.fields,
            isAll , 
            needChecking ,
            totalDuration,
            isOver ,
            actionsField,
          ]
        
          : this.activeFilter === "inChecking" && authHelpers.isUserCentral()
        ? [
            ...this.fields,
            needChecking,
            actionsField,
          ]
        : [...this.fields , isAll  ,totalDuration , actionsField ];
    },

  },
  methods: {
    ...mapActions("Ministry/Settings/Transaction", ["reAssignmentTransaction"]),
    onFilterChanged(filter) {
      this.activeFilter = filter;
    },
    formatDate(value , formFormat) {
      return formatDate(value, formFormat);
    },
    onClickedReAssignment(id){
      this.form = { transaction_id : id}
      this.reAssignment = true
    },
    onConfirmReAssignment(form){
      this.reAssignmentTransaction(form).then(async() => {
          this.reAssignment = false
          this.form = {}
          this.$refs.transactionsTable.refreshTable();
        });
    },
    specifiedPeriodHasExceeded(endData){
      return ifSpecifiedPeriodHasExceeded(endData)
    }
  },
};
</script>
<style lang="scss" scoped>
.advanced-report {
  position: fixed;
  bottom: 2%;
  z-index: 1031;
  right: 2%;
}
</style>
